import React, { Component } from 'react';

class AlertMessage extends Component {
  componentDidMount() {
    const { hideMessage } = this.props;

    // https://getbootstrap.com/docs/3.3/javascript/#modals
    $('#trevorAlertMessage').modal({
      backdrop: this._dismissable ? undefined : 'static',
      keyboard: this._dismissable,
      show: true,
    });

    if (this._dismissable) {
      $('#trevorAlertMessage').on('hidden.bs.modal', function () {
        hideMessage(); // need to trigger this here, as there are multiple ways the modal can be closed (such as user clicking X in top right, or user clicking outside the modal)
      });
    }
  }

  static hide() {
    $('#trevorAlertMessage').modal('hide');
  }

  render() {
    const { message, hideMessage } = this.props;
    this._dismissable = message.dismissable;
    return (
      <div>
        <div
          className="modal fade"
          id="trevorAlertMessage"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body text-align-center">
                {message.content}
              </div>
              <div className="modal-footer text-align-center">
                <button
                  type="button"
                  className="btn btn-outline-dark"
                  onClick={hideMessage}
                >
                  {message.buttonName}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlertMessage;
